// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1rQTL","errorLogs":"EditorFooter_errorLogs__i14yt"};